import Api from '@/api'

export default {
  namespaced: true,

  state: {
    suggestions: [],
  },

  mutations: {
    setSuggestions(state, suggestions) {
      state.suggestions = suggestions
    },
  },

  actions: {
    async getSuggestions({ commit }, searchQuery) {
      const { data } = await Api.get(`places/suggestions?input=${searchQuery}`)
      commit('setSuggestions', data.data)
    },
  },
}
